<app-header></app-header>
<app-hero-section></app-hero-section>

<app-section id="athena"
             [titre]="'Athena'"
             [theme]="SectionColor.White"
             [sousTitre]="'En quelques mots'"
              data-aos="fade-up" data-aos-anchor-placement="center-bottom">
  <div class="text-content" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom">
    <p>Athena, c'est quoi ? Une idée, un projet lancé par trois amis à la recherche d'un challenge, de changements et d'innovations. Durant l’été 2024, une idée est née, attirant notre curiosité pour <b>l'intelligence artificielle.</b></p>
    <p>Au même titre qu'Internet a changé la face du monde, l'IA va probablement devenir un nouvel outil incontournable dans la vie de tous les jours.</p>
    <p>Nous sommes conscients que pour beaucoup, l'IA reste quelque chose de mystérieux, un gadget, que ChatGPT, c'est sympa pour avoir la meilleure recette de cuisine ou pour créer une histoire personnalisée pour border nos enfants. Mais l'IA offre bien plus que ça.</p>
    <p>Notre idée est d'utiliser la puissance de l'IA pour rendre vos données d'entreprise encore plus utiles et accessibles. Que ce soit avec un chatbot pour simplifier vos processus, un agent d’aide à la décision pour orienter vos choix stratégiques, ou d’autres solutions sur mesure, nous vous aidons à tirer pleinement parti de vos données.</p>
  </div>
</app-section>
<app-section id="solutions"
             [titre]="'Nos solutions'"
             [sousTitre]="'Ce que nous proposons'"
             [theme]="SectionColor.Gray" data-aos="fade-up">
  <div class="group-content" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom">
    <div class="image-content">
      <app-image [imageUrl]="'/assets/images/neural_network.png'"></app-image>
    </div>
    <div class="text-content">
      <h3>Découvrez nos solutions basées sur l’architecture RAG</h3>
      <p>
        Nos solutions sont conçues pour transformer la façon dont vous interagissez avec vos données. Imaginez un éventail de possibilités technologiques adaptées à vos besoins, allant de l’analyse avancée à l’assistance intelligente, grâce à l’intelligence artificielle. Nos premières recherches et analyses se sont orientées vers les chatbots, une solution robuste basée sur l'architecture RAG (Retrieval-Augmented Generation). Mais ce n’est qu’un exemple de ce que nous pouvons développer pour répondre à vos besoins uniques.
      </p>
      <p>
        L'architecture RAG fonctionne comme un bibliothécaire virtuel ultra-performant: lorsqu'une question est posée, elle utilise deux étapes essentielles pour y répondre. D’abord, elle effectue une recherche d'information, un peu comme parcourir une immense bibliothèque. Ensuite, elle génère une réponse: après avoir consulté les meilleures ressources, elle reformule les informations en une réponse claire et directe.
      </p>
      C’est sur cette architecture flexible que nous avons basé nos recherches, nous permettant de comprendre les nombreuses possibilités d’implémentation dont voici quelques exemples:
      <ul>
        <li>Automatiser la recherche d’information</li>
        <li>Optimiser des processus décisionnels</li>
        <li>Répondre à des besoins spécifiques liés aux données de votre entreprise</li>
        <li>Rendre la visite de votre site web plus interactive et dynamique</li>
      </ul>
      <p>
        Notre <b>Chatbot Athena</b>, un outil résultant de nos recherches, illustre parfaitement la puissance de cette approche: un assistant intelligent capable de répondre à vos questions en s’appuyant sur des sources précises, comme vos documents PDF, contenus web, ou bases de données. Il incarne notre vision: tirer parti de vos données pour maximiser leur valeur.
      </p>
    </div>
  </div>
  <div class="group-content" data-aos="fade-up" data-aos-delay="200" data-aos-anchor-placement="center-bottom">
    <div class="text-content">
          <h3>Simplifiez la recherche d’information de manière efficace</h3>
          <p>
            Que vous cherchiez à automatiser une tâche spécifique ou à optimiser la gestion de vos données, notre approche garantit des réponses contextualisées, vérifiables et pertinentes pour vos besoins ce qui vous permet de vous libérer des contraintes techniques. L’exemple de Chatbot Athena montre comment une solution bien conçue peut devenir votre assistant quotidien: rapide, précis et accessible en tout temps, il vous aide à optimiser vos processus internes et à gagner un temps précieux.
          </p>
       </div>
      <div class="image-content">
        <app-image [imageUrl]="'/assets/images/laptop_nature.png'"></app-image>
      </div>
     </div>
     <div class="group-content" data-aos="fade-up" data-aos-delay="300" data-aos-anchor-placement="center-bottom">
       <div class="image-content">
         <app-image [imageUrl]="'/assets/images/ia_tech.png'"></app-image>
       </div>
       <div class="text-content">
         <h3>Confidentialité et flexibilité intégrées</h3>
         <p>
           La confidentialité de vos données est notre priorité. Avec notre architecture, vous avez le choix entre différents modèles de langage (LLM). Vous pouvez ainsi opter pour un modèle hébergé localement, afin de garantir que vos données restent en interne, ou choisir une option cloud selon vos préférences.
         </p>
       </div>
     </div>
     <div class="group-content" data-aos="fade-up" data-aos-delay="400" data-aos-anchor-placement="center-bottom">
         <div class="text-content">
           <h3>Une architecture modulaire et adaptable</h3>
           <p>
             S’intégrer à des systèmes existants est un point essentiel dans l’implémentation d’une solution.
           </p>
           <p>
             Notre équipe sera à votre disposition pour vous aider, vous orienter dans la mise en place de la solution idéale et vous accompagnera à chaque étape pour la personnaliser selon vos exigences. Nous assurons également un suivi et une maintenance continus pour répondre à tous besoins.
           </p>
         </div>
     </div>
  <div class="group-content" data-aos="fade-up" data-aos-delay="400" data-aos-anchor-placement="center-bottom">
    <div class="text-content">
      <h3>Tirez pleinement parti de vos données</h3>
      <p>
        Accélérez vos recherches, optimisez vos processus internes et explorez les possibilités multiples de l’intelligence artificielle avec des solutions conçues pour la flexibilité, la sécurité et la performance. Que ce soit pour un chatbot ou d’autres applications basées sur l’IA, notre expertise est là pour donner vie à vos idées.
      </p>
    </div>
  </div>
</app-section>
<app-section  id="workflow"
              [titre]="'Processus'"
              [sousTitre]="'Notre démarche'"
              [theme]="SectionColor.White">
  <div class="circle-container">
    <div class="card-wrapper card-1">
      <app-card
        [iconUrl]="'/assets/images/icons/analyse.svg'"
        [hoverIconUrl]="'/assets/images/icons/analyse_hover.svg'"
        [title]="'1 - Analyse'"
        [description]="'Analyse de vos besoins et données afin d\'évaluer la faisabilité de mise en place d\'une solution adaptée.'">
      </app-card>
    </div>
    <div class="card-wrapper card-2">
      <app-card
        [iconUrl]="'/assets/images/icons/index.svg'"
        [hoverIconUrl]="'/assets/images/icons/index_hover.svg'"
        [title]="'2 - Indexation'"
        [description]="'Indexation de vos données (PDF, contenus web, etc).'">
      </app-card>
    </div>
    <div class="card-wrapper card-3">
      <app-card
        [iconUrl]="'/assets/images/icons/icon-chatbot.svg'"
        [hoverIconUrl]="'/assets/images/icons/icon-chatbot-hover.svg'"
        [title]="'3 - Exploitation'"
        [description]="'Utilisation d\'une solution adaptée qui permettra de tirer pleinement parti de vos données.'">
      </app-card>
    </div>
    <div class="card-wrapper card-4">
      <app-card
        [iconUrl]="'/assets/images/icons/evaluation.svg'"
        [hoverIconUrl]="'/assets/images/icons/evaluation_hover.svg'"
        [title]="'4 - Évaluation'"
        [description]="'Analyse et validation des réponses fournies par le système pour garantir leur pertinence et leur fiabilité.'">
      </app-card>
    </div>
  </div>
</app-section>

<!--<app-section id="team"-->
<!--             [titre]="'Team'"-->
<!--             [sousTitre]="'Qui sommes-nous ?'"-->
<!--             [theme]="SectionColor.Blue" data-aos="fade-up">-->
<!--    <div class="image-content">-->
<!--      <app-image [imageUrl]="'/assets/images/photos/jeremy.jpg'"-->
<!--                 [bottomCenterText]="'Jérémy Wermeille'" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom"></app-image>-->
<!--      <app-image [imageUrl]="'/assets/images/photos/sebastien.jpg'"-->
<!--                 [bottomCenterText]="'Sébastien Quiquerez'" data-aos="fade-up" data-aos-delay="150" data-aos-anchor-placement="center-bottom"></app-image>-->
<!--      <app-image [imageUrl]="'/assets/images/photos/jonas.jpg'" data-aos="fade-up" data-aos-delay="200" data-aos-anchor-placement="center-bottom"-->
<!--                 [bottomCenterText]="'Jonas Caillet'"></app-image>-->
<!--    </div>-->
<!--</app-section>-->

<app-section id="contact"
             [titre]="'Contact'"
             [sousTitre]="'Vous souhaitez prendre contact ?'"
             [theme]="SectionColor.Gray">
  <div class="image-content">
    <a href="mailto:info@athena-technologies.ch?subject=Demande d'informations&body=Bonjour, je souhaite obtenir des informations..."   class="email-button">
      Nous envoyer un mail
    </a>
  </div>
</app-section>
<app-section id="demo" *ngIf="isLoggedIn"
             [titre]="'Demo'"
             [sousTitre]="'Section de démonstration'"
             [theme]="SectionColor.Gray" data-aos="fade-up">
  <div class="cards-container">
    <app-card
      [iconUrl]="'/assets/images/icons/icon-scraping.svg'"
      [hoverIconUrl]="'/assets/images/icons/icon-scraping-hover.svg'"
      [title]="'Scrapping'"
      [description]="'Le composant permettant de faire du scrapping de sites web.'"
      (cardClick)="onCardScrappingClicked()" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom">
    </app-card>
    <app-card
      [iconUrl]="'/assets/images/icons/icon-upload.svg'"
      [hoverIconUrl]="'/assets/images/icons/icon-upload-hover.svg'"
      [title]="'FileUpload'"
      [description]="'Le composant permettant d\'upload des documents PDF.'"
      (cardClick)="onCardUploadClicked()" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom">
    </app-card>
    <app-card
      [iconUrl]="'/assets/images/icons/icon-chatbot.svg'"
      [hoverIconUrl]="'/assets/images/icons/icon-chatbot-hover.svg'"
      [title]="'ChatBot Athena'"
      [description]="'Le chatbot qui vous permettra de posez n\'importe quelle question en rapport aux documents uploadés.'"
      (cardClick)="onCardChatBotClicked()" data-aos="fade-up" data-aos-delay="100" data-aos-anchor-placement="center-bottom">
    </app-card>
    <div class="expandable-div" [ngClass]="{ 'open': isCardUploadOpen }">
      <app-athena-file-upload [apiUrl]="apiUrl"></app-athena-file-upload>
    </div>
    <div class="expandable-div" [ngClass]="{ 'open': isCardScrappingOpen }">
      <app-athena-scrapping [apiUrl]="apiUrl"></app-athena-scrapping>
    </div>
  </div>
</app-section>
<app-footer>
  <div>
    © 2024 Athena Solutions. Tous droits réservés.
  </div>
</app-footer>
<div *ngIf="isCardChatBotOpen">
  <app-athena-chatbot [apiUrl]="apiUrl"></app-athena-chatbot>
</div>
